import React, { Component } from 'react';
import CSSModules from 'react-css-modules'
import Helmet from 'react-helmet'
import { Link, GetStartedInput } from '../../components'
import Styles from './NotFound.css'

@CSSModules(Styles)
export default class NotFound extends Component {
  constructor(props) {
    super(props)
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  render() {
    return (
      <div styleName='page'>
        <div styleName='main'>
          <div styleName='notfound'>
            <Helmet title='404 Not found'/>
            <h1>Sorry, nothing here.</h1>
            <p>
              <Link
                xstrong={true}
                to={'/'}
                title='Home'>
                Click here to return to the home page and get started.
              </Link>
            </p>
          </div>
        </div>

        <GetStartedInput />

      </div>
    )
  }
}
